export class Body {
	public constructor(public id: string, public name: string) {}
}
